module.exports = __webpack_public_path__ + "static/media/julia-lose.f5279596.jpg";